// no conflict
var $ = jQuery.noConflict();

$(document).ready(function() {

  $('.js-mobile-menu-open').click(function() {

    $(this).toggleClass('is-active');
    $('html, body').toggleClass('overflow-h');
    $('.mobile-menu').toggleClass('is-active');

    return false;
  });



  $('.mobile-menu__menu .menu-item-has-children > a').click(function() {

    if ($(this).parent().hasClass('is-active')) {
      return true;
    }

    $(this).parent().toggleClass('is-active');

    return false;
  });


});

